import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        yhmc: null, // 用户名称
        zsxm: null, // 真实姓名
        qgdm: null, // 行政监督部门
        showSameAuditPowerFlag: null, // 是否显示同级单位权限
        yhlb: null, // 用户类别
      },
      // 表单错误
      errRules: {
       
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: this.$route.query.type,// 操作标志
      id: this.$route.query.id,  // 主键
      /*****************************全部核验权限****************************/
      nodeUserLoading: false, // 列表loading状态
      // 查询表单字段
      nodeUserForm: {
        qgdm: null, // 区管部门
        nodeUser: null, // 用户编号
        processDistinguish: null, // 流程类别
        showSameAuditPowerFlag: null, // 是否显示同级单位权限
      },
      // 表格基础数据
      nodeUserTableColumns: [
        {
          label: "招标投标监管部门名称",
          prop: "competentDepartName",
        },
        {
          label: "流程名",
          prop: "processName",
        },
        {
          label: "节点名",
          prop: "nodeName",
        },
        {
          label: "是否有该核验权限",
          slotName: "nodeUserId",
        },
      ],
      // 表格数据
      nodeUserTableData: [],
    };
  },
  // 注册组件
  components: {

  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 获取详情信息
    this.fun_Details();
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/spProcessNodeUser/detail", {
        id: this.id, // 主键
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data;
          // 核验权限一览查询
          this.fun_NodeUserList();
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
    * @description 核验权限一览
    * @author
    */
    fun_NodeUserList() {
      // 区管部门
      this.nodeUserForm.qgdm = this.form.qgdm,
      // 用户编号
      this.nodeUserForm.nodeUser = this.form.id,
      // 用户类别
      this.nodeUserForm.processDistinguish = this.form.yhlb,
      // 是否显示同级单位权限
      this.nodeUserForm.showSameAuditPowerFlag = this.form.showSameAuditPowerFlag,
      // 请求，获取结果集
      fun_PostAction("/spProcessNodeUser/spProcessNodeUserList", {
       ...this.nodeUserForm, // 查询表单
      }).then(res => {
        // 解构res.data
        const {
          result,
          data
        } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.nodeUserTableData = data;
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 单选改变事件
     * @author shuhua
     */
    fun_GetRadioVal(e, i) {
      // 赋值
      this.form[i] = e;
      // 如果是是否显示同级单位权限
      if (i == "showSameAuditPowerFlag") {
        // 核验权限一览查询
        this.fun_NodeUserList();
      }
    },
    /**
     * 保存修改
     * @param e
     */
    fun_InsUpd() {
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
           // 提交的方法
           this.fun_Submit();
        } else {
          return false;
        }
      });
    },
    /**
     * 提交
     * @author shuhua
     */
    fun_Submit() {
      try {
        // 选中值集合
        let key = "";
        // 遍历列表数据
        for (const index in this.nodeUserTableData){
          // 如果是否有该操作权限勾选
          if (this.nodeUserTableData[index].nodeUserId) {
            // 拼接
            key += this.nodeUserTableData[index].nodeId + ",";
          }
        }
        // 请求
        fun_PostAction("/spProcessNodeUser/save", {
          nodeUser: this.form.id, // 用户编号
          key: key,
        }).then(res => {
          // 解构res.data
          const {
            result,
            data,
            msg
          } = res.data;
          // 解析后台返回的结果集，判断是否成功
          if (result) {
            // 操作成功
            this.$message.success(msg);
            // 返回一览
            this.fun_Back();
          } else {
            // 如果页面验证失败
            if (data != null && data != "") {
              // 返回错误消息
              this.errRules = data;
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("您输入的数据存在错误！");
            } else {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error(msg);
            }
          }
          // 关闭loading
          this.loading = false;
        });
      } catch (e) {
        // 请求失败，弹出失败msg的消息提示
        this.$message.error("操作失败！" + e);
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
  }
};
